import { fmtMoney } from '@/lib/format'

/** Russian labels for the provider-fee vocabulary (docs/accounting.md §Комиссии). */

export const FEE_PROVIDER_LABEL: Record<string, string> = {
  heleket: 'Heleket, приём крипты',
  sbp: 'СБП (PayGateCore и общий)',
  idmpay: 'СБП через IDMPay',
  wata: 'СБП через WATA',
  stars: 'Telegram Stars',
  heleket_payout: 'Heleket, выплаты партнёрам',
}

export const FEE_KIND_LABEL: Record<string, string> = {
  acquiring: 'Эквайринг',
  conversion: 'Конвертация и курс',
  payout_network: 'Сетевая комиссия выплаты',
  stars_withdrawal: 'Вывод Stars в TON',
}

/** Where a fee number came from. Tone + word, never colour alone (design §6.5). */
export const FEE_SOURCE: Record<string, { label: string; tone: 'ok' | 'neutral' | 'warn' }> = {
  provider_actual: { label: 'Факт провайдера', tone: 'ok' },
  provider_quote: { label: 'Котировка', tone: 'neutral' },
  rule_estimate: { label: 'По правилу', tone: 'warn' },
}

/** Rubles with kopecks, grouped («1 490,00»); the caller adds «₽». Exact (lib/format, WP-04). */
export const rub2 = (v: string | number) => fmtMoney(v)
